(function () {
    'use strict';

    angular.module('app')
        .directive('locationSelect', function() {
            return {
                templateUrl: 'components/directives/location_select/view.location_select.html',
                controller: 'locationSelectController',
                controllerAs: 'vm',
                scope: {
                    "locationChange": "&",
                    "location": "="
                },
                bindToController: true
            }
        });
})();
